module.exports = __webpack_public_path__ + "img/y-259.60ca79b7.png";